export enum ACCESSIBILITY_ROLES {
    DIALOG = "dialog",
    ALERTDIALOG = "alertdialog",
    HEADING = "heading",
    BUTTON = "button",
    CHECKBOX = "checkbox",
    ALERT = "alert",
    GROUP = "group",
}

export enum ARIA_LIVE {
    POLITE = "polite",
    ASSERTIVE = "assertive",
    OFF = "off",
}
